import { Link, useLocation } from 'react-router-dom'
import { Logo } from '@/shared/components/layout/navigation/logo'
import { useNavItems } from '@/shared/components/layout/navigation/nav-items'
import { COLLECTION_ANCHOR_ATTR } from '@/shared/lib/collection-tab'
import { emitTabRetap } from '@/shared/lib/tab-retap'
import { cn } from '@/shared/lib/utils'

export function TopNav() {
  const { pathname } = useLocation()
  const items = useNavItems()

  return (
    <header
      data-app-nav="top"
      // Positioned for the same reason as the bottom bar: the Collection canvas takes the
      // whole window and paints underneath this.
      className="relative z-10 hidden w-full shrink-0 items-center justify-between border-b border-app-grey-200 bg-white px-[48px] py-[16px] lg:flex"
    >
      <Logo />
      <nav className="flex items-center gap-[16px]">
        {items.map((item) => {
          const isActive =
            item.path === '/plan'
              ? pathname === '/plan' || pathname.startsWith('/plan/')
              : pathname.startsWith(item.path)
          return (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => {
                if (pathname === item.path) emitTabRetap(item.path)
              }}
              className={cn(
                'flex items-center gap-[6px] p-[8px] text-base tracking-[-0.02em] transition-colors duration-150',
                isActive
                  ? 'font-medium text-app-primary-600 hover:text-app-primary-900'
                  : 'font-normal text-app-grey-800 hover:text-black',
              )}
            >
              {/* One height for every tab; the icon inside keeps the size it was drawn at. */}
              <span className="flex h-5.5 items-center">
                <span
                  className="relative inline-flex"
                  // The fan measures this to know where to land; only the Collection tab has one.
                  {...(item.path === '/collection'
                    ? { [COLLECTION_ANCHOR_ATTR]: true }
                    : {})}
                >
                  <item.icon />
                  {item.hasDot && (
                    // Anchored to the icon, not the label: the label is a different width in
                    // every language.
                    <span className="absolute -top-[1px] -right-[3px] size-[5px] rounded-full bg-app-error ring-1 ring-white" />
                  )}
                </span>
              </span>
              <span>{item.desktopLabel}</span>
            </Link>
          )
        })}
      </nav>
    </header>
  )
}
